export function ArchiveBanner({ what }: { what: string }) {
  return (
    <div className="mb-5 rounded-xl border border-amber-500/20 bg-amber-500/[0.06] px-4 py-3 text-sm text-amber-200/90 flex items-start gap-2.5">
      <span className="text-base leading-none mt-0.5">🗄️</span>
      <div>
        <b>Старая модель — архив.</b> {what} держим только для справки и пересадки клиентов на
        новую инфраструктуру (<b>Хосты</b> + <b>Подписки</b>). Новые выдачи сюда не идут.
      </div>
    </div>
  );
}
